module.exports = __webpack_public_path__ + "media/newstyle/images/book-type-004d08b2f3197f217060727c75da5ec4.png";